import { ErrorStateMatcher } from '@angular/material/core';

import { FormControl, FormGroupDirective, NgForm, AbstractControl, ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';
import { ElementRef } from '@angular/core';

export class ParentErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
    return (invalidCtrl || invalidParent);
  }
}

export class CrossFieldErrorMatcher implements ErrorStateMatcher {

  errorType1: string;
  errorType2: string;

  constructor(errorType1: string, errorType2: string) {
    this.errorType1 = errorType1;
    this.errorType2 = errorType2;
  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      return control.touched && (form.hasError(this.errorType1) || form.hasError(this.errorType2));
  }
}

export class ThreeFieldErrorMatcher implements ErrorStateMatcher {

  errorType1: string;
  errorType2: string;
  errorType3: string;

  constructor(errorType1: string, errorType2: string, errorType3: string) {
    this.errorType1 = errorType1;
    this.errorType2 = errorType2;
    this.errorType3 = errorType3;
  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      return control.touched && (form.hasError(this.errorType1) || form.hasError(this.errorType2) || form.hasError(this.errorType3));
  }
}


// export class ParentErrorStateMatcher implements ErrorStateMatcher {
//   isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//     // console.log(form);
//     return control.dirty && form.invalid;
//   }
// }

export function identityValidator(control1: string, control2: string): ValidatorFn {
  return (control: FormGroup): ValidationErrors | null => {
    const a = control.get(control1);
    const b = control.get(control2);
    return a.value !== b.value ? { identity: true } : null;
  };
}

export function checkInvalid(fgs: FormGroup[], form: ElementRef, focus: boolean): boolean {
  for (const fg of fgs) {
    for (const name in fg.controls) {
      if (fg.controls[name].invalid) {
        if (focus) {
          const ele = form.nativeElement.querySelector('[formControlName=' + name + ']');
          if (ele) {
            ele.focus();
          }
        }
        return true;
      }
    }
    if (fg.invalid) {
      return true;
    }
  }
  return false;
}
